module.exports = __webpack_public_path__ + "static/media/facebook-homepage.27e291ba.png";